/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.2.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NextPortArrival
 */
export interface NextPortArrival {
    /**
     * 
     * @type {number}
     * @memberof NextPortArrival
     */
    imo: number;
    /**
     * Estimated Time of Arrival (ETA) in ISO Extended format (UTC). This value doesn't exists if the ship has already arrived the port.
     * @type {string}
     * @memberof NextPortArrival
     */
    eta: string;
    /**
     * UNLOCODE
     * @type {string}
     * @memberof NextPortArrival
     */
    locode: string;
    /**
     * ID for the current trip for the given vessel. This will change at every port call
     * @type {number}
     * @memberof NextPortArrival
     */
    id: number;
    /**
     * Fraction 0..1 of probability
     * @type {number}
     * @memberof NextPortArrival
     */
    probability: number;
}

/**
 * Check if a given object implements the NextPortArrival interface.
 */
export function instanceOfNextPortArrival(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "imo" in value;
    isInstance = isInstance && "eta" in value;
    isInstance = isInstance && "locode" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "probability" in value;

    return isInstance;
}

export function NextPortArrivalFromJSON(json: any): NextPortArrival {
    return NextPortArrivalFromJSONTyped(json, false);
}

export function NextPortArrivalFromJSONTyped(json: any, ignoreDiscriminator: boolean): NextPortArrival {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'imo': json['imo'],
        'eta': json['eta'],
        'locode': json['locode'],
        'id': json['id'],
        'probability': json['probability'],
    };
}

export function NextPortArrivalToJSON(value?: NextPortArrival | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'imo': value.imo,
        'eta': value.eta,
        'locode': value.locode,
        'id': value.id,
        'probability': value.probability,
    };
}

